import React, { Component } from "react";
import { Link } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Skeleton from "react-loading-skeleton";

import "./GenrePage.less";
import GenreSearchResultsContainer from "./GenreSearchResultsContainer";

class GenreListPage extends Component {
  constructor(...args) {
    super(...args);

    this.state = {
      hasSearched: false,
      letter: "",
      searchTerms: "",
    };
  }

  handleSubmit(event) {
    event.preventDefault();
    event.stopPropagation();

    const form = event.currentTarget;
    const termsVal = form.terms.value.trim();

    if (termsVal.length > 2 && this.state.searchTerms !== termsVal) {
      this.setState({ hasSearched: true, searchTerms: termsVal });
    }
  }

  startsWith(letter) {
    if (letter.length === 1) {
      this.setState({ hasSearched: true, letter: letter });
    }
  }

  render() {
    return (
      <div className="genre-list-page-component">
        <Row>
          <Col xs={12}>
            <div className="page-header">
              <h2>File Under / Genres</h2>
            </div>
          </Col>
          <Col xs={12}>
            <div className="page-header text-center">
              <Form className="genre-search-form" noValidate onSubmit={(e) => this.handleSubmit(e)}>
                <Row>
                  <Col xs={12} sm={12} md={{ span: 6, offset: 3 }} className="">
                    <Form.Group controlId="terms">
                      <Form.Label>Find a Dream Chimney style genre by name.</Form.Label>
                      <Form.Control className="search-text" type="text" autoComplete="off" />
                      <Button variant="primary" type="submit">
                        Search
                      </Button>
                    </Form.Group>
                  </Col>
                </Row>
              </Form>
            </div>
          </Col>
          <Col className="alpha-filter text-center" xs={12}>
            {"abcdefghijklmnopqrstuvwxyz".split("").map((letter) => (
              <span key={letter}>
                <button className={this.state.letter === letter ? " button active" : "button"} onClick={() => this.startsWith(letter)}>
                  {letter}
                </button>
              </span>
            ))}
            <span>
              <button className={this.state.letter === "1" ? " button active" : "button"} onClick={() => this.startsWith("1")}>
                0-9
              </button>
            </span>
          </Col>
          <Col xs={12}>
            <GenreSearchResultsContainer
              letter={this.state.letter}
              terms={this.state.searchTerms}
              render={({ genres_chunked, loading }) => (
                <Row className="genre-search-results">
                  {this.state.hasSearched && (
                    <Col xs={12}>
                      <div className="totd-header search-results-header sm">Results</div>
                    </Col>
                  )}
                  {loading && (
                    <Col xs={12}>
                      <div className="loading">
                        <Skeleton count={3} />
                      </div>
                    </Col>
                  )}
                  {this.state.hasSearched && !loading && genres_chunked.length === 0 && (
                    <Col xs={12}>
                      <div className="loading">
                        <h5>Oddly nothing found for that genre. </h5>
                        <p>We have thousands of genres so you're bound to find something eventually.</p>
                      </div>
                    </Col>
                  )}
                  {genres_chunked.map((genres, index) => (
                    <Col className="genre-list-col" xs={12} sm={6} md={4} key={index}>
                      {genres.map((genre) => (
                        <div key={genre.id}>
                          {genre.total >= 5 && <FontAwesomeIcon icon="trophy" className="trophy" />}
                          <Link to={`/genre/${genre.id}`}>{genre.genre}</Link> {genre.total && <span>( {genre.total} )</span>}
                        </div>
                      ))}
                    </Col>
                  ))}
                </Row>
              )}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

export default GenreListPage;
